import { render, staticRenderFns } from "./PiDialogContactList.vue?vue&type=template&id=1fd084f4&scoped=true"
import script from "./PiDialogContactList.vue?vue&type=script&lang=js"
export * from "./PiDialogContactList.vue?vue&type=script&lang=js"
import style0 from "./PiDialogContactList.vue?vue&type=style&index=0&id=1fd084f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd084f4",
  null
  
)

export default component.exports